<template>
  <UCard>
    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div class="flex items-center gap-4">
        <div class="p-3 bg-primary/10 rounded-lg shrink-0">
          <UIcon :name="icon || 'i-lucide-power'" class="w-6 h-6 text-primary" />
        </div>
        <div class="min-w-0">
          <h3 class="text-lg font-bold truncate">{{ title || 'Aktivierung' }}</h3>
          <p class="text-sm text-muted line-clamp-2 sm:line-clamp-none">
            {{ description || 'Komponente aktivieren oder deaktivieren.' }}
          </p>
        </div>
      </div>
      <div class="flex items-center justify-between sm:justify-end gap-3 shrink-0">
        <span class="text-sm font-medium" :class="modelValue ? 'text-primary' : 'text-muted'">
          {{ modelValue ? 'Aktiviert' : 'Deaktiviert' }}
        </span>
        <USwitch
          :model-value="modelValue"
          v-bind="$attrs"
          color="primary"
          @update:model-value="$emit('update:modelValue', $event)"
        />
      </div>
    </div>
  </UCard>
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
})
defineProps({
  modelValue: Boolean,
  title: String,
  description: String,
  icon: String,
})

defineEmits(['update:modelValue'])
</script>
